import React from 'react';
import { Icon } from '../core/Icon.jsx';

const GLYPHS = { success: 'check_circle', error: 'error', info: 'info' };

/** Bottom-center dark toast. Parent owns visibility/auto-hide. */
export function Toast({ open = false, variant = 'success', icon, children, className = '' }) {
  if (!open) return null;
  return (
    <div className="bjl-toast-wrap">
      <div className={`bjl-toast bjl-toast--${variant} ${className}`} role="status">
        <Icon name={icon || GLYPHS[variant] || GLYPHS.info} fill />
        {children}
      </div>
    </div>
  );
}
